<template>
    <Teleport to="body">
        <dx-popup
            ref="popupRef"
            v-for="widget in store.state.cardWidgetList.widgetOpenedList"
            :id="widget.id"
            :key="widget.id"
            :title="getTitle(widget)"
            :hint="widget.name"
            :visible="widget.visible"
            :height="widget.height || '80vh'"
            :width="widget.width || '80vw'"
            :closeOnOutsideClick="true"
            :drag-enabled="true"
            :resize-enabled="true"
            :shading="false"
            :show-close-button="true"
            :animation="{ value: false }"
            :show-title="true"
            @hidden="onHidden"
            @hiding='onClosePopup'
        >
            <component
                ref="instanceRef"
                :is="widget.component"
                :action="getInstance"
                :id="widget.id"
                :userData="userData"
                @close-popup="emitOnClosePopup"
            />
        </dx-popup>
    </Teleport>
</template>

<script setup>
import { DxPopup } from 'devextreme-vue/popup';
import { useStore } from 'vuex';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { getCookie } from '@/utils/cookies';
import { mainState, setIsWidgetOpening } from '@/layouts/main-layout/main-layout-data';


onMounted(() => {});

defineProps({
    userData: {
        type: Object,
        default: () => {
            return {};
        },
    },
});
const popupRef = ref();
const instanceRef = ref();
const appId = ref(+getCookie('app'));
const popupOpenNow = ref();
const popupClose = ref(false);

const getInstance = async inst => {
    if (mainState.isWidgetOpening) {
        await inst.setDataSource();
    }
};

const store = useStore();
const getTitle = widget => {
    const caption = widget.caption ? widget.caption.map(c => store.state.cardWidgetList.cardFormData[c]).join(' ') : '';
    return `${widget.name} ${caption}`;
};
const onHidden = event => {
    popupClose.value = false;
    popupRef.value = event;
    setIsWidgetOpening(false);
    const closedWidgetIndex = store.getters.getOpenedWidgetByName(event.element.title);
    store.dispatch('hidePopupWidgetWindow', { index: closedWidgetIndex });
};

const onClosePopup =(event) => {
    if(appId.value === 250) {
        popupOpenNow.value = event;
        if(popupClose.value) return;
        const widget = store.state.cardWidgetList.widgetMetaList.find(w => w.id === popupOpenNow.value.element.id);
        const widgetRef =  instanceRef.value.find(i => i.id === popupOpenNow.value.element.id);
        if(widget.isGrid) {
            event.cancel = true;
            if(typeof widgetRef.beforeInstanceClose === 'function') {
                widgetRef.beforeInstanceClose();
            }
        }
    }
}

const emitOnClosePopup = (widgetName) => {
    if(appId.value === 250) {
        const widget = store.state.cardWidgetList.widgetOpenedList.find(w => w.component.name === widgetName);
        if(widget.visible) {
            popupClose.value = true;
            widget.visible = false;
            popupOpenNow.value.component?.hide();
        }
    }
}
</script>
